import React, { useContext } from 'react'
import QualityIndicatorIcon from './QualityIndicatorIcon'
import { TextContext } from 'hocs'
import { bool, oneOf } from 'prop-types'

const IndicatorDescriptionTable = ({ type, isMobile }) => {
  const textContext = useContext(TextContext)

  const descriptionMapOutOf5 = {
    '5OutOf5': 5,
    '4OutOf5': 4,
    '3OutOf5': 3,
    '2OutOf5': 2,
    '1OutOf5': 1,
    '0OutOf5': 0,
    singleCase: -1,
  }
  const descriptionMapOutOf4 = {
    '4OutOf4': 4,
    '3OutOf4': 3,
    '2OutOf4': 2,
    '1OutOf4': 1,
    '0OutOf4': 0,
  }

  return (
    <>
      <div style={{ maxWidth: '750px', margin: '5px 0' }}>
        <div>
          {textContext['nursingIndicatorTable.indicatorDescription.title']}
        </div>
        {isMobile && type === 'circle-indicators' && (
          <div style={{ height: '23px', margin: '10px 0 16px 0' }}>
            {`${ textContext['nursingIndicatorTable.indicatorDescription.phrasePrepend'] }...`}
          </div>
        )}
      </div>
      {type === 'circle-indicators' &&
        Object.keys(descriptionMapOutOf5).map((description, index) => (
          <div
            key={ `circle-wrapper-${ index }` }
            style={{ maxWidth: '750px', display: 'flex', margin: '5px 0' }}>
            <span className={ 'description-value' }>
              <QualityIndicatorIcon
                key={ `circle-icon-${ index }` }
                shape={ 'circle' }
                value={ descriptionMapOutOf5[description] }
                maxValue={ 5 }
              />
            </span>
            <span className={ 'description-meaning' }>
              {!isMobile &&
                descriptionMapOutOf5[description] > 0 &&
                textContext[
                  `nursingIndicatorTable.indicatorDescription.phrasePrepend`
                ]}
              {
                textContext[
                  `nursingIndicatorTable.indicatorDescription.${ description }`
                ]
              }
            </span>
          </div>
        ))}
      {type === 'square-indicators' &&
        Object.keys(descriptionMapOutOf4).map((description, index) => (
          <div
            key={ `square-wrapper-${ index }` }
            style={{ maxWidth: '750px', display: 'flex', margin: '5px 0' }}>
            <span className={ 'description-value' }>
              <QualityIndicatorIcon
                key={ `square-icon-${ index }` }
                shape={ 'square' }
                value={ descriptionMapOutOf4[description] }
                maxValue={ 4 }
              />
            </span>
            <span className={ 'description-meaning' }>
              {
                textContext[
                  `nursingIndicatorTable.indicatorDescription.${ description }`
                ]
              }
            </span>
          </div>
        ))}
    </>
  )
}

IndicatorDescriptionTable.defaultProps = {
  type: 'circle-indicators',
}

IndicatorDescriptionTable.propTypes = {
  type: oneOf(['circle-indicators', 'square-indicators']),
  isMobile: bool.isRequired,
}

export default IndicatorDescriptionTable
